var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6 4C6 3.44772 6.44772 3 7 3V3C7.55228 3 8 3.44772 8 4V4C8 4.55228 7.55228 5 7 5V5C6.44772 5 6 4.55228 6 4V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5C9 4.44772 9.44772 4 10 4V4C10.5523 4 11 4.44772 11 5V5C11 5.55228 10.5523 6 10 6V6C9.44772 6 9 5.55228 9 5V5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 9.44772 4.44772 9 5 9V9C5.55228 9 6 9.44772 6 10V10C6 10.5523 5.55228 11 5 11V11C4.44772 11 4 10.5523 4 10V10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8 9C8 8.44772 8.44772 8 9 8V8C9.55228 8 10 8.44772 10 9V9C10 9.55228 9.55228 10 9 10V10C8.44772 10 8 9.55228 8 9V9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M3 6C3 5.44772 3.44772 5 4 5V5C4.55228 5 5 5.44772 5 6V6C5 6.55228 4.55228 7 4 7V7C3.44772 7 3 6.55228 3 6V6Z",
    fill: "white"
  })));
};
export default __webpack_public_path__ + "static/media/tree-scatter-icon.4e2d7b55.svg";
export { SvgComponent as ReactComponent };